import { Reveal } from "@/components/Reveal";

export const SectionHead = ({ overline, title, accent, sub, center = false, as: Tag = "h2", light = false }) => (
  <div className={center ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}>
    <Reveal>
      <p className={`mb-4 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.3em] ${light ? "text-gold" : "text-brand"}`}>
        <span className="h-px w-8 bg-current" />
        {overline}
      </p>
    </Reveal>
    <Reveal delay={0.1}>
      <Tag
        className={`font-display text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl ${
          Tag === "h1" ? "text-4xl sm:text-5xl lg:text-6xl" : ""
        } ${light ? "text-white" : "text-forest"}`}
      >
        {title} {accent && <span className="text-gold">{accent}</span>}
      </Tag>
    </Reveal>
    {sub && (
      <Reveal delay={0.2}>
        <p className={`mt-6 text-base leading-relaxed sm:text-lg ${light ? "text-white/85" : "text-brand-hover"}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);
